import { MenuButtonFragmentFragment } from '../../__generated__/graphql';
import { MenuButtonItem } from '../../components/Button/MenuButton';

export const menuButtonFragmentToMenuButtonItems = (menuButtonFragment: MenuButtonFragmentFragment): MenuButtonItem[] =>
  (menuButtonFragment.menuButton?.menubutton ?? []).map((item): MenuButtonItem => ({
    href: item?.menubuttonlink?.url ?? '',
    label: item?.menubuttonlink?.title ?? '',
    target: item?.menubuttonlink?.target,
  }));
